module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-12-9b7e1e0f0db68323380f3e1acb46e900.jpg";